/* ========== 対象処理 ========== */
// パスワード再設定
// 1. パスワード再設定用メール送信
// 2. パスワード再設定処理

document.addEventListener("DOMContentLoaded", function () {
  const sendResetPasswordButton = document.getElementById('send_email_button');
  const resetPasswordArea = document.querySelector('.account-changePassword');
  const resetPasswordButton = document.getElementById('reset_password_button');
  const passwordResetCompleteArea = document.getElementById('password_reset_complete_area');

  // パスワード再設定用メール送信（パスワード失念 or 移行会員）
  const fogot_pass_form = document.getElementById("fogot_pass_form");
  if (sendResetPasswordButton) {
    fogot_pass_form.addEventListener("submit", async (e) => {
      e.preventDefault();
      sendResetPasswordEmail(sendResetPasswordButton);
    });
  }

  // パスワード再設定ボタン
  const pass_reset_form = document.getElementById("pass_reset_form");
  if (resetPasswordButton) {
    checkResetPasswordToken(resetPasswordArea);

    pass_reset_form.addEventListener("submit", async (e) => {
      e.preventDefault();
      resetPassword(resetPasswordButton);
    });
  }

  //パスワード再設定完了画面
  if(passwordResetCompleteArea){
    passwordResetComplete(passwordResetCompleteArea);
  }

});

// パスワード再設定tokenチェック
const sendResetPasswordEmail = async (sendResetPasswordButton) => {
  const url = `${APP_PROXY_URL}/api/send_password_reset_mail`;
  let successMessage = document.getElementById('success_send_message');
  let errorMessage = document.getElementById('error_send_message');
  successMessage.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';
  btnLoading(sendResetPasswordButton);

  const params = validateResetPasswordEmail();
  if (!params) {
    btnStopLoading(sendResetPasswordButton);
    return;
  }

  const res = await fetchPostMethod(url, params);

  if (res.message == 'ok') {
    successMessage.innerHTML = '手続きメールを送信しました。内容を確認してください。<br>※メールが受信できない場合は、<a href="https://www.isseymiyake.com/blogs/faq/membership#guide1-0-3">こちら</a>をご確認ください。';
  } else {
    if(res.message == undefined){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = res.message;
    }
    errorMessage.style.display = "block";
  }
  btnStopLoading(sendResetPasswordButton);
};

// パスワード再設定tokenチェック
const checkResetPasswordToken = async (resetPasswordArea) => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  let formItem = document.querySelector('._login');

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    for(i = 0; i < resetPasswordArea.childElementCount; i++){
      resetPasswordArea.children[i].style.display = 'none';
    }

    for(i = 0; i < formItem.childElementCount; i++){
      formItem.children[i].style.display = 'none';
    }

    formItem.style.display = "block";
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    errorMessage.style.display = "block";
    return;
  }
};

// パスワード再設定処理
const resetPassword = async (resetPasswordButton) => {
  const url = `${APP_PROXY_URL}/api/reset_password`;
  let successMessage = document.getElementById('success_message');
  let errorMessage = document.getElementById('error_message');
  successMessage.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';
  btnLoading(resetPasswordButton);

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  const params = validateResetPassword(token);
  if (!params) {
    btnStopLoading(resetPasswordButton);
    return;
  }

  const res = await fetchPostMethod(url, params);
  if (res.message == 'ok') {
    window.location.href = `https://${location.hostname}/pages/password_reset_complete?token=${token}`;
  } else {
    errorMessage.innerText = res.message;
    errorMessage.style.display = 'block';
    btnStopLoading(resetPasswordButton);
  }
};

//パスワード再設定完了画面
const passwordResetComplete = async (completeArea) => {
  let errorMessage = document.getElementById('error_message');

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    for(i = 0; i < completeArea.childElementCount; i++){
      completeArea.children[i].style.display = 'none';
    }

    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    errorMessage.style.display = "block";
    return;
  }

}